import { Create, Datagrid, Edit, ImageField, List, SaveButton, SimpleForm, TextField, TextInput, Toolbar ,EditButton,DeleteButton,ImageInput} from "react-admin";
import UploadImage from '../shared/uploadImage';

export const CategoryList = (props) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="name" />
                <ImageField source="image" />
                <EditButton></EditButton>
                          <DeleteButton mutationMode="pessimistic" />

            </Datagrid>
        </List>
    )
}

export const CategoryCreate = (props) => {

    return (
        <Create {...props} dir="rtl" redirect="list">
            <SimpleForm>
                <TextInput source="name" />
                <UploadImage name="image" />
            </SimpleForm>
        </Create>
    )
}

const UserEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);


export const CategoryEdit = (props) => {
    return (<Edit {...props} >
        <SimpleForm toolbar={<UserEditToolbar />}>
            <TextInput source="name" />
            <UploadImage name="image" />
        </SimpleForm>
    </Edit>)
}


